import React from "react";
import PropTypes from "prop-types";
import { Field } from "react-final-form";

import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const IncidentPropertyShareForm = ({ classes, submitting, loading }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <div>
        <Box className={classes.marginTop}>
          <Field name="email">
            {({ input, meta }) => (
              <TextField
                {...input}
                label="Email address"
                variant="outlined"
                fullWidth
                error={meta.touched && Boolean(meta.error)}
                helperText={meta.touched && meta.error}
              />
            )}
          </Field>
        </Box>

        <Box
          className={classes.marginTop}
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          alignItems={{ xs: "stretch", sm: "center" }}
          gap={2}
        >
          <Field name="expiresAt" initialValue={null}>
            {({ input }) => (
              <DatePicker
                label="Set expiration"
                value={input.value || null}
                disablePast
                onChange={(newValue) => input.onChange(newValue ?? null)}
                slotProps={{
                  textField: {
                    variant: "outlined",
                    fullWidth: true,
                    placeholder: "No expiry",
                  },
                }}
                sx={{ flex: 1 }}
              />
            )}
          </Field>

          <Button
            disabled={submitting || loading}
            type="submit"
            variant="contained"
            color="primary"
            sx={{ height: 56 }}
          >
            Share link
          </Button>
        </Box>
      </div>
    </LocalizationProvider>
  );
};

export default IncidentPropertyShareForm;
